export const FEATURE_NAME = '@zerops/zerops/core/integration-token-base';
